<template>
  <div class="personeel">
  <div>Dit is de personeels pagina</div>
<section>
           <div>+ gebruiker toevoegen {{userProfile.company}}</div>
        </section>
<section>
<div id="employee-table" v-if="users.length">
    <table class='table table-hover'>
      <thead  class="thead-light">
        <tr>
          <th>#</th>
          <th>voornaam</th>
          <th>achternaam</th>
          <th>email</th>
          <th>telefoon</th>
          <th>positie(s)</th>
          <th>vestiging(en)</th>
          <th>acties</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in users" :key="user.id">
          <td>{{index + 1}}</td>
          <td>{{user.firstname}}</td>
          <td>{{user.lastname}}</td>
          <td>{{user.email}}</td>
          <td>{{user.phonenumber}}</td>
          <td>todo</td>
          <td>todo</td>
          <td>del | suspend</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-if="!users | !users.length">Er zijn geen gebruikers.</div>
</section>
  </div>
</template>

<script>

//const fb = require('./firebaseConfig.js')
import { mapState } from 'vuex'

export default {  
  name: 'Personeel',
  components: {
  },
  computed: {
    ...mapState(['currentUser', 'userProfile', 'users'])
  },
  data() {
       return {
      employees: [
        {
          id: 1,
          name: 'Richard Hendricks',
          email: 'richard@piedpiper.com',
        },
        {
          id: 2,
          name: 'Bertram Gilfoyle',
          email: 'gilfoyle@piedpiper.com',
        },
        {
          id: 3,
          name: 'Dinesh Chugtai',
          email: 'dinesh@piedpiper.com',
        },
        {
          id: 4,
          name: 'Ik Zelf',
          email: 'Ik@zelf.nl',
        },
        {
          id: 5,
          name: 'Ik Zelf',
          email: 'Ik@zelf.nl',
        },
      ],
    }
    },
    methods: {
    }
}
</script>

